import React from 'react';
import { RadioGroup, RadioGroupItem } from '../../ui/radio-group';

const AFSSCopyToLOSection = ({ formData, handleInputChange, isDark }) => {
    if (formData.recipientSource !== 'strata' || formData.sending !== 'AFSS copy to LO') {
        return null;
    }

    return (
        <div className={`border-solid border-[1px] rounded-[16px] p-[20px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.11)] w-full max-w-[822px] flex flex-col gap-[16px] transition-colors duration-200 ${
            isDark ? 'bg-[#000000] border-[#292929]' : 'bg-white border-[#d9d9d9]'
        }`}>
            <div className={`text-[16px] font-semibold transition-colors duration-200 ${
                isDark ? 'text-white' : 'text-[#072837]'
            }`}>
                AFSS copy to LO <span className='text-[#FF0000]'>*</span>
            </div>
            <RadioGroup
                value={formData.afssCopyToLO || ''}
                onValueChange={(value) => handleInputChange('afssCopyToLO', value)}
                className="flex flex-col gap-[12px]"
            >
                {['Lodgement', 'Record'].map((option) => (
                    <label key={option} className="flex items-center gap-[8px] cursor-pointer">
                        <RadioGroupItem 
                            value={option}
                            id={`afssCopyToLO-${option.toLowerCase()}`}
                            disabled
                        />
                        <span className={`text-[16px] font-normal transition-colors duration-200 ${
                            isDark ? 'text-white' : 'text-[#072837]'
                        }`}>
                            {option}
                        </span>
                    </label>
                ))}
            </RadioGroup>
        </div>
    );
};

export default AFSSCopyToLOSection;
